module.exports = __webpack_public_path__ + "static/img/botprofile@3x.c55d35b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/botprofile@3x.jpg
// module id = 88xm
// module chunks = 6